import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "../lib/api";
import { Loading, Logo } from "../components/Shared";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [already, setAlready] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); setError("This verification link is missing its token."); return; }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then((r) => {
        setAlready(!!r.data.already_verified);
        setState("success");
      })
      .catch((e) => { setState("error"); setError(e?.response?.data?.detail || "Verification failed."); });
  }, [params]);

  return (
    <div className="p1-container flex justify-center py-16 lg:py-24" data-testid="verify-email-page">
      <div className="p1-card w-full max-w-md p-10 text-center">
        <div className="flex justify-center"><Logo /></div>
        {state === "loading" && <div className="mt-8"><Loading label="Verifying your email…" /></div>}
        {state === "success" && (
          <div className="mt-8" data-testid="verify-success">
            <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-700" />
            <h1 className="mt-4 font-heading text-2xl font-bold text-stone-900">
              {already ? "Email already verified" : "Email verified successfully"}
            </h1>
            <p className="mt-2 text-sm text-stone-600">
              {already ? "Your ParentOne account is ready — you're all set." : "Your ParentOne account is ready. Welcome to the family."}
            </p>
            <button onClick={() => navigate("/login")} className="p1-btn-primary mt-6 w-full" data-testid="verify-continue-btn">Continue to Login</button>
          </div>
        )}
        {state === "error" && (
          <div className="mt-8" data-testid="verify-error">
            <XCircle className="mx-auto h-14 w-14 text-terracotta" />
            <h1 className="mt-4 font-heading text-2xl font-bold text-stone-900">This link can't be used</h1>
            <p className="mt-2 text-sm text-stone-600">{error}</p>
            <button onClick={() => navigate("/login")} className="p1-btn-primary mt-6 w-full" data-testid="verify-login-btn">Go to Login</button>
            <p className="mt-3 text-xs text-stone-400">If your account is already verified, you can simply log in.</p>
          </div>
        )}
      </div>
    </div>
  );
}
